import {
  LogoAfwerxImage,
  LogoEYImage,
  LogoPhilipsImage,
  LogoPWCImage,
  LogoUHGImage,
} from 'Assets/Image/CompanyLogos'

export const WE_HAVE_PERFECT_REPUTATION_LOGOS = [
  {
    id: 'WeHavePerfectReputationLogos-Philips',
    name: 'Philips',
    image: LogoPhilipsImage,
  },
  {
    id: 'WeHavePerfectReputationLogos-Afwerx',
    name: 'AFWERX',
    image: LogoAfwerxImage,
  },
  {
    id: 'WeHavePerfectReputationLogos-PWC',
    name: 'PwC',
    image: LogoPWCImage,
  },
  {
    id: 'WeHavePerfectReputationLogos-EY',
    name: 'EY',
    image: LogoEYImage,
  },
  {
    id: 'WeHavePerfectReputationLogos-UHG',
    name: 'UnitedHealth Group',
    image: LogoUHGImage,
  },
]
